/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { PersonalAccessToken } from "./PersonalAccessToken";
export const PersonalAccessTokensResponse = core.serialization.object({
    data: core.serialization.list(PersonalAccessToken),
});
